import { redPacketHero } from '@/mocks/red-packet';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      {/* 背景：深色 + 暖金流动光带 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Deep%20dark%20background%20with%20abstract%20flowing%20golden%20light%20ribbons%20and%20scattered%20red%20envelope%20shapes%20glowing%20warmly%2C%20a%20subtle%20network%20of%20urban%20shopfronts%20and%20storefront%20lights%20faintly%20visible%20in%20the%20distance%2C%20warm%20red%20and%20gold%20gradient%20lighting%20over%20dark%20charcoal%20base%2C%20festive%20digital%20fintech%20atmosphere%2C%20soft%20cinematic%20glow%2C%20high%20detail%2C%20wide%20panoramic%20composition%2C%20editorial%20illustration%20style&width=1600&height=900&seq=redpacket-hero-bg-01&orientation=landscape"
          alt="数字红包"
          title="数字红包解决方案"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/88 to-foreground-950/60"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-transparent to-foreground-950/70"></div>
      </div>

      {/* 暖金光晕装饰 */}
      <div className="absolute -top-20 -right-20 w-72 h-72 md:w-96 md:h-96 rounded-full bg-secondary-500/10 blur-3xl animate-float-slow pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 md:w-[28rem] md:h-[28rem] rounded-full bg-accent-500/10 blur-3xl animate-float-slow pointer-events-none" style={{ animationDelay: '2s' }}></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 pb-20 md:pt-40 md:pb-24 min-h-[640px] md:min-h-[720px] flex items-center">
        <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* 左栏：文案 */}
          <div className="w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur">
              <span className="w-2 h-2 rounded-full bg-secondary-400"></span>
              <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
                {redPacketHero.eyebrow}
              </span>
            </div>

            <h1 className="mt-6 font-heading font-bold text-background-50 text-3xl md:text-5xl leading-tight">
              {redPacketHero.title}
            </h1>

            <p className="mt-6 text-sm md:text-base text-foreground-200 leading-relaxed max-w-xl">
              {redPacketHero.subtitle}
            </p>
            <p className="mt-3 text-xs md:text-sm text-foreground-400 leading-relaxed max-w-xl">
              {redPacketHero.note}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#consultation"
                className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-secondary-500 text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-secondary-400"
              >
                {redPacketHero.primaryLabel}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#scenarios"
                className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md border border-background-50/30 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/10"
              >
                {redPacketHero.secondaryLabel}
              </a>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              {redPacketHero.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/15 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* 右栏：主视觉 */}
          <div className="relative w-full">
            <div className="relative rounded-lg overflow-hidden border border-background-50/15">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20festive%20digital%20red%20envelope%20floating%20in%20a%20warm%20glowing%20center%20with%20flowing%20golden%20light%20ribbons%20swirling%20around%20it%2C%20surrounded%20by%20floating%20digital%20currency%20coins%20and%20small%20connected%20storefront%20icons%2C%20deep%20dark%20background%20with%20warm%20red%20and%20gold%20gradient%2C%20celebratory%20yet%20sophisticated%20fintech%20aesthetic%2C%20soft%20cinematic%20glow%2C%20high%20detail%2C%20centered%20composition%2C%20editorial%20illustration%20style&width=1000&height=720&seq=redpacket-hero-visual-02&orientation=landscape"
                alt="数字红包系统主视觉"
                title="数字红包系统主视觉"
                className="w-full h-[300px] md:h-[420px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 to-transparent"></div>

              {/* 信息浮层（示意） */}
              <div className="absolute top-4 left-4 px-3 py-2 rounded-md bg-foreground-950/70 backdrop-blur border border-background-50/15">
                <div className="text-[10px] text-foreground-300 whitespace-nowrap">发放进度</div>
                <div className="text-sm font-semibold text-secondary-300 whitespace-nowrap">定向发放 · 实时中</div>
              </div>
              <div className="absolute bottom-4 right-4 px-3 py-2 rounded-md bg-foreground-950/70 backdrop-blur border border-background-50/15">
                <div className="text-[10px] text-foreground-300 whitespace-nowrap">核销状态</div>
                <div className="text-sm font-semibold text-accent-300 whitespace-nowrap">支付即核 · 已留痕</div>
              </div>
            </div>
            <p className="mt-3 text-right text-[11px] text-foreground-400">
              界面为示意呈现，非真实业务数据
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}